import createAction from "../../../actions/safeCreateAction";
export const setInstallerSandbox = createAction("SET_INSTALLER_SANDBOX", (enabled) => enabled);
